/**
 * Curated list of ISO 3166-1 alpha-2 country codes shown in the
 * country picker. Names are resolved at runtime via
 * `Intl.DisplayNames` so they appear in the user's current language.
 */
import { countryCodeToFlag } from './countryFlag';

// Most-relevant ~90 markets for the app's target audience.
export const COUNTRY_CODES = [
  'IT', 'SM', 'VA',
  'GB', 'IE', 'US', 'CA', 'AU', 'NZ', 'ZA',
  'ES', 'MX', 'AR', 'CO', 'PE', 'CL', 'VE', 'EC', 'UY', 'PY', 'BO',
  'DO', 'CR', 'PA', 'GT', 'HN', 'SV', 'NI', 'CU', 'PR',
  'PT', 'BR', 'AO', 'MZ',
  'DE', 'AT', 'CH', 'LI', 'LU',
  'FR', 'BE', 'MC',
  'NL', 'DK', 'SE', 'NO', 'FI', 'IS',
  'PL', 'CZ', 'SK', 'HU', 'RO', 'BG', 'GR', 'HR', 'SI', 'RS', 'AL', 'MT', 'CY',
  'EE', 'LV', 'LT',
  'UA', 'RU', 'BY', 'TR',
  'IL', 'AE', 'SA', 'QA', 'KW', 'BH', 'OM', 'JO', 'LB', 'EG', 'MA', 'TN', 'DZ',
  'IN', 'PK', 'BD', 'LK', 'NP',
  'CN', 'JP', 'KR', 'TW', 'HK', 'SG', 'MY', 'TH', 'VN', 'ID', 'PH',
  'NG', 'KE', 'GH', 'ET',
];

const _displayNamesCache = new Map();

function getDisplayNames(language) {
  const lang = (language || 'en').slice(0, 2).toLowerCase();
  if (_displayNamesCache.has(lang)) return _displayNamesCache.get(lang);
  let dn = null;
  try {
    if (typeof Intl !== 'undefined' && typeof Intl.DisplayNames === 'function') {
      dn = new Intl.DisplayNames([lang], { type: 'region' });
    }
  } catch (_) {
    dn = null;
  }
  _displayNamesCache.set(lang, dn);
  return dn;
}

/** Return localized country name (e.g. "Italia" for it+IT). Falls back to code. */
export function getCountryName(code, language) {
  if (!code) return '';
  const cc = code.trim().toUpperCase();
  const dn = getDisplayNames(language);
  if (!dn) return cc;
  try {
    return dn.of(cc) || cc;
  } catch (_) {
    return cc;
  }
}

/** List of {code, flag, name} sorted alphabetically by localized name. */
export function getCountryList(language) {
  return COUNTRY_CODES
    .map((code) => ({
      code,
      flag: countryCodeToFlag(code),
      name: getCountryName(code, language),
    }))
    .sort((a, b) => a.name.localeCompare(b.name, language || 'en'));
}
